<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const actions = computed(
  () =>
    (props.message.actions?.length
      ? props.message.actions
      : props.message.buttons) || []
);
</script>

<template>
  <div
    class="rounded-xl divide-y bg-n-alpha-2 divide-n-strong text-n-slate-12 max-w-80"
  >
    <div class="px-3 py-2.5">
      <img
        v-if="message.image_url"
        :src="message.image_url"
        class="w-full max-h-44 rounded-lg"
        :alt="$t('WHATSAPP_TEMPLATE_MGMT.PREVIEW.MEDIA_ALT')"
      />
      <div class="flex flex-col gap-2" :class="{ 'pt-2.5': message.image_url }">
        <h6 v-if="message.title" class="font-semibold">{{ message.title }}</h6>
        <span
          v-if="message.content"
          v-dompurify-html="message.content"
          class="text-sm prose prose-bubble"
        />
      </div>
    </div>
    <div
      v-for="(action, index) in actions"
      :key="index"
      class="flex justify-center items-center p-3"
    >
      <Button
        :label="
          action.title ||
          action.text ||
          t('WHATSAPP_TEMPLATE_MGMT.PREVIEW.BUTTON')
        "
        link
        class="hover:!no-underline"
      />
    </div>
  </div>
</template>
